var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return (_vm.customer.customer_id)?_c('el-link',{attrs:{"type":"primary"},on:{"click":function($event){return _vm.handleClick(_vm.customer.customer_id)}}},[_vm._v("\n  "+_vm._s(_vm.customer.customer_name || '')+"\n")]):_vm._e()}
var staticRenderFns = []

export { render, staticRenderFns }